import { pluralize } from 'src/lib/format';

export const STRUCTURE_INSTRUCTIONS_LABEL = 'Format and vocabulary';
/** The label inside a sentence. */
export const STRUCTURE_INSTRUCTIONS_TERM = STRUCTURE_INSTRUCTIONS_LABEL.toLowerCase();
export const STRUCTURE_INSTRUCTIONS_SUBLABEL =
  'Choose from the available options, or type custom formatting instructions here';
export const STRUCTURE_INSTRUCTIONS_LABEL_WITH_CASCADE_WARNING = `${STRUCTURE_INSTRUCTIONS_LABEL} (will be applied to all assets)`;
export const STRUCTURE_INSTRUCTIONS_APPLY_LABEL = `Apply ${STRUCTURE_INSTRUCTIONS_TERM}`;

export const AI_CHAT_LABEL = 'Content Agent';
export const CONTENT_IMPROVER_LABEL = 'Content Improver';
export const LOCALIZATION_LABEL = 'Localization';
export const BLOG_WIZARD_LABEL = 'Blog Wizard';
// The left sidebar draws it on two lines.
export const BLOG_WIZARD_SIDEBAR_LABEL = 'Blog\nWizard';
export const GENERATION_TEMPLATES_LABEL = 'Generation Templates';
export const TEMPLATES_LABEL = 'Templates';
export const BLANK_PROJECT_LABEL = 'Blank Project';

// The tool tooltips are said once, for the Home cards and the project's left panel alike.
export const TEMPLATES_TOOLTIP =
  'Generate campaigns, emails, landing pages, and more with proven templates';
export const BLOG_WIZARD_TOOLTIP = 'Generate SEO/AEO optimized blog posts';
export const CONTENT_IMPROVER_TOOLTIP = 'Improve content for performance and brand compliance';
export const LOCALIZATION_TOOLTIP = 'Adapt your content for different languages and markets';

export const prepareKeywordHint = ({
  maxKeywords,
  maxWordsPerKeyword,
  disabled,
  disabledKeywordsHint,
}: {
  maxKeywords: number;
  maxWordsPerKeyword: number;
  disabled: boolean;
  disabledKeywordsHint: string;
}) => {
  if (disabled) {
    return disabledKeywordsHint;
  }

  if (maxWordsPerKeyword === 1) {
    return 'Include a 1-word talking point.';
  }

  const postfix = pluralize(maxWordsPerKeyword, 'word', 'words');
  if (maxKeywords === 1) {
    return `Include a talking point. It can be up to ${maxWordsPerKeyword} ${postfix}.`;
  }
  return `Add up to ${maxKeywords} talking points.\nEach talking point can be up to ${maxWordsPerKeyword} ${postfix} long.`;
};
